module.exports = __webpack_public_path__ + "img/factory-bg.8587b880.8587b880.jpg";